import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Typography,
	Icon
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	'@keyframes spin': {
		'0%': {
			transform: 'rotate(0deg)',
		},
		'100%': {
			transform: 'rotate(360deg)',
		},
	},
	spinner: {
		width: 60,
		height: 60,
		border: '4px solid #f3f3f3',
		borderTop: '4px solid #3498db',
		borderRadius: '50%',
		animation: '$spin 1s linear infinite',
		marginBottom: 20
	},
	progressContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '20px 0'
	},
	progressBar: {
		width: '100%',
		height: 4,
		backgroundColor: '#f0f0f0',
		borderRadius: 2,
		marginTop: 20,
		overflow: 'hidden'
	},
	progressFill: {
		height: '100%',
		backgroundColor: '#3498db',
		transition: 'width 0.3s ease',
		borderRadius: 2
	}
}));

const VncProgressDialog = ({ 
	open, 
	cluster, 
	vncConnectionStatus, 
	vncConnectionSteps 
}) => {
	const classes = useStyles();

	const progressPercentage = vncConnectionStatus.currentStep >= 0 
		? ((vncConnectionStatus.currentStep + 1) / vncConnectionSteps.length) * 100 
		: 0;


	return (
		<Dialog
			open={open}
			onClose={(event, reason) => {
				// Prevent closing on backdrop click and escape key
				if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
					return;
				}
			}}
			maxWidth="sm"
			fullWidth
		>
			<DialogTitle>
				<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
					<Icon>desktop_windows</Icon>
					Connecting to {cluster?.name}
				</div>
			</DialogTitle>
			<DialogContent>
				<div className={classes.progressContainer}>
					<div className={classes.spinner} />
					<Typography variant="h6" style={{ marginBottom: 8, textAlign: 'center' }}>
						{vncConnectionStatus.message}
					</Typography>
					{vncConnectionStatus.currentStep >= 0 && (
						<Typography variant="body2" color="textSecondary" style={{ textAlign: 'center' }}>
							Step {vncConnectionStatus.currentStep + 1} of {vncConnectionSteps.length}
						</Typography>
					)}
					
					{/* Progress indicator */}
					<div className={classes.progressBar}>
						<div 
							className={classes.progressFill}
							style={{ width: `${progressPercentage}%` }}
						/>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default VncProgressDialog;
